(ns teamoesterreich.admin-mode.training.training-overview
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.training :as d-trainings]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.training.training-detail-form :as training-detail-form]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.message :as message-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [goog.json :as json]
            [clojure.string :as str]

            [teamoesterreich.admin-mode.training.training-user-table :as training-user-table]
            [teamoesterreich.admin-mode.training.training-slot-user-table :as training-slot-user-table]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.send :refer [send]]
            ))



(defn get-it []
  (let []
    (fn []
      (let [!tab (r/cursor vstate/app-state [:training-tab])
            !training (r/cursor vstate/app-state [:selected-training])
            !actual-user (r/cursor store/app-state [:actual-user])
            !show-delete? (r/cursor vstate/app-state [:trainingEvent-delete])
            !training-invite-popup? (r/cursor vstate/app-state [:trainingEvent-invite-loaded])
            !training-detail-loaded? (r/cursor vstate/app-state [:trainingEvent-detail-loaded])
            !show-start-warn? (r/cursor vstate/app-state [:show-start-warn])
            !show-end-warn? (r/cursor vstate/app-state [:show-end-warn])
            !show-end-not-possible? (r/cursor vstate/app-state [:show-end-not-possible])
            training-timeFrom (:trainingEvent-timeFrom @!training)
            training-status (or (:trainingEvent-status @!training) "created")
            member-cnt (count (:trainingEvent-slotMember @!training))
            training-step (case training-status
                            "created" 0
                            "waitAccept" 1
                            "collecting" 2
                            "running" 3
                            "finished" 4
                            "closed" 4
                            0)
            cnt-responseStatus-fn (fn [response-filter] (count (filter (fn [e] (and (case response-filter
                                                                                      "invited" (and (some? (:trainingSlotMember-invitation e)) (= (or (:trainingSlotMember-responseState e) "undefined") "undefined"))
                                                                                      "accepted" (and (= (:trainingSlotMember-responseState e) "accepted") (= "undefined" (or (:trainingSlotMember-state e) "undefined")))
                                                                                      "member" (and (empty? (:trainingSlotMember-invitation e)) (= (or (:trainingSlotMember-responseState e) "undefined") "undefined"))
                                                                                      :else true)
                                                                                    ))
                                                                       (:trainingEvent-slotMember @!training))))

            cnt-missionStatus-fn (fn [status] (count (filter (fn [e] (= status (or (:trainingSlotMember-state e) "undefined"))) (:trainingEvent-slotMember @!training))))
            ]

        ;(log/debug "Actual training  " @!training-detail-loaded? @!training)


        [mui/grid
         {:container false :item true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:marginTop "5px"}
          }

         [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                      :onClick   #(swap! vstate/app-state assoc :site :trainingEvent-list)
                      }
          "Zurück"]

         [mui/button {:startIcon (r/as-element [refresh])
                      :onClick   #(reset! !training-detail-loaded? false)}
          "Neu laden ...."
          ]]

        (if-not @!training-detail-loaded?
          (do
            (if (:trainingEvent-uuid @!training)
              (d-trainings/<training-load (:trainingEvent-uuid @!training)
                                          (fn [response]
                                            (reset! !training response)
                                            (reset! !training-detail-loaded? true)
                                            ))
              (a/set-page :training-list))
            [mui/grid
             {:container false :item true
              :md        12                                 ;medium: 960px
              :xs        12                                 ;extra-small: 0px
              :style     {:marginTop "5px"}
              }
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )

          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "5px"}
            }
           [mui/card
            [mui/grid {:container true :direction "row" :justify "flex-start" :alignItems "flex-start"}
             [mui/grid {:container false :item true :xs 9}
              [mui/card-header {:title   (str "Veranstaltung " (:trainingEvent-name @!training))
                                :onClick #(reset! !training-detail-loaded? false)
                                }]
              ]
             [mui/grid {:container false :item true :xs 3}
              [ws-event-sync-component/ws-event-reload !training-detail-loaded? :training-event (:trainingEvent-uuid @!training)]
              ]
             ]

            [mui/card-content {}
             [mui/stepper {:active-step training-step}
              [mui/step {
                         :key "Step1"
                         }
               [mui/step-label "Erstellen"]]

              [mui/step {
                         :key "Step2"
                         }
               [mui/step-label "Wartet auf Freischalten"]]

              [mui/step {
                         :key "Step3"
                         }
               [mui/step-label "Sammelt Rückmeldungen"]]

              [mui/step {
                         :key "Step4"
                         }
               [mui/step-label "Aktiv"]]

              [mui/step {
                         :key "Step5"
                         }
               [mui/step-label "Abgeschlossen"]]
              ]]

            [mui/card-content {}
             [are-you-sure-modal/are-you-sure-modal !show-delete? "Nur für Superuser! Veranstaltung wirklich löschen ?" "löschen"
              (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-active false}
                                                 (fn [data] (swap! vstate/app-state assoc
                                                                   :selected-training nil
                                                                   :trainingEvent-detail-loaded false
                                                                   :site :trainingEvent-list
                                                                   ))))]

             [are-you-sure-modal/are-you-sure-modal !training-invite-popup? "Möchtest du neuen Teilnehmern (noch nicht Eingeladene) jetzt die Einladung senden? " "senden"
              (fn [] (d-trainings/>training-send-invitation (:trainingEvent-uuid @!training) nil #(reset! !training-detail-loaded? false)))]

             [are-you-sure-modal/are-you-sure-modal !show-start-warn? "Möchtest du diese Veranstaltung auf gestartet setzen? " "Starten"
              (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "running"} (fn [data] (reset! !training-detail-loaded? false))))]

             [are-you-sure-modal/are-you-sure-modal !show-end-warn? "Willst du diesen Veranstaltung beenden ?" "beenden"
              (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training)
                                                 {:trainingEvent-status "finished"
                                                  :trainingEvent-timeTo (or (:trainingEvent-timeTo @!training)
                                                                            (let [date (js/Date.)]
                                                                              (goog.string.format "%04d%02d%02dT%02d%02d%02d.000Z" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date) (.getSeconds date)) ;20180701T100000.000Z
                                                                              ))
                                                  } (fn [data] (reset! !training-detail-loaded? false))))]

             [message-modal/modal !show-end-not-possible? (r/as-element [:p [warning] [:br] "Diese Veranstaltung ist nicht abschließbar! " [:br] "Prüfe ob alle Teilnehmer eingeteilt sind"])]

             (when (= training-status "created")
               [mui/button {:variant   "outlined" :color "secondary"
                            :disabled  (not (and
                                              (> (count (str (:trainingEvent-timeFrom @!training))) 0)
                                              (> (count (str (:trainingEvent-name @!training))) 0)
                                              (> (count (str (:trainingEvent-acceptableUntil @!training))) 0)
                                              ))
                            :startIcon (r/as-element [check])
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "waitAccept"} (fn [data] (reset! !training-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten beantragen"])


             (when (and (= training-status "waitAccept") (d-rights/allow-admin-for d-rights/TRAINING_ACTIVATE))
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "created"} (fn [data] (reset! !training-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Ablehnen"])

             (when (and (= training-status "waitAccept") (d-rights/allow-admin-for d-rights/TRAINING_ACTIVATE))
               [mui/button {:variant   "outlined" :color "secondary"
                            
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "collecting" :trainingEvent-published true} (fn [data] (reset! !training-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten"])





             (when (and (= training-status "collecting"))
               [mui/button {:variant "outlined"
                            :color   "primary"
                            :title   "Wird nur an die gesendet, die noch keine Einladung erhalten haben!"
                            :onClick #(reset! !training-invite-popup? true)
                            :style   {:marginRight "10px"}}
                (str "Einladung an alle senden")])

             (when (and (= training-status "collecting"))
               [mui/button {:variant  "outlined"
                            :disabled (or (nil? training-timeFrom)
                                          (< (.getTime (new js/Date)) (js/Date.parse (str (subs training-timeFrom 6 8) "." (subs training-timeFrom 4 6) "." (subs training-timeFrom 0 4)))))
                            :color    "secondary"
                            :onClick  (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "running"} (fn [data] (reset! !training-detail-loaded? false))))
                            :style    {:marginRight "10px"}}
                "Veranstaltung starten"])

             (when (= training-status "running")
               [mui/button {:variant  "outlined"

                            :disabled (> (cnt-responseStatus-fn "accepted") 0)
                            :onClick  (fn [] (if (and (= training-status "running") (> (cnt-responseStatus-fn "accepted") 0))
                                               (reset! !show-end-not-possible? true)
                                               (reset! !show-end-warn? true)
                                               ))
                            :color    "secondary"
                            :style    {:marginRight "10px"}}
                "Veranstaltung abschließen"])

             [:div {:style {:display "inline-block" :width "200px"}}]

             (when (= training-status "created")
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [delete-outline])
                            :onClick   #(reset! !show-delete? true)
                            :style     {:marginRight "10px"}}
                "Löschen"])

             (when (and (= training-status "collecting") (d-rights/allow-admin-for d-rights/TRAINING_ACTIVATE))
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "created" :trainingEvent-published false} (fn [data] (reset! !training-detail-loaded? false))))
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "Freischaltung zurücknehmen"])

             (when (= training-status "collecting")
               [mui/button {:variant   "outlined"
                            :onClick   #(reset! !show-start-warn? true)
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :style     {:marginRight "10px" :color "orange"}}
                "Veranstaltung starten"])

             (when (= training-status "running")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "collecting"} (fn [data] (reset! !training-detail-loaded? false))))
                            
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "starten zurücknehmen"])

             (when (= training-status "finished")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "running"} (fn [data] (reset! !training-detail-loaded? false))))
                            
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "beenden zurücknehmen"])

             (when (and (= training-status "created") (d-rights/is-superuser?))
               [mui/button {:variant   "outlined" :color "secondary"
                            :title     "Nur Superuser, versendet kein Mail/SMS"
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :onClick   (fn [] (d-trainings/>training-save (:trainingEvent-uuid @!training) {:trainingEvent-status "collecting" :trainingEvent-published true} (fn [data] (reset! !training-detail-loaded? false))))
                            :style     {:marginRight "10px" :color "orange"}}
                "Direkt Freischalten (superuser)"])

             ]
            [:span {:style {:color "red"}}
             (str
               (when (< member-cnt 1) "Keine Personen zugeteilt, ")
               (when (< (count (str (:trainingEvent-timeFrom @!training))) 5) "Beginn Datum fehlt, ")
               (when (< (count (str (:trainingEvent-name @!training))) 1) "Name fehlt, ")
               (when (< (count (str (:trainingEvent-acceptableUntil @!training))) 5) "Anmelde Ende fehlt, ")


               (when (and (= training-status "running") (> (cnt-responseStatus-fn "accepted") 0))
                 (str (cnt-responseStatus-fn "accepted") " Teilnehmer noch nicht zugeteilt (teilgenommen/nicht erschienen)")))]
            [:br]
            [:br]
            ]
           [:br]
           [mui/card
            [mui/card-content {}
             (log/debug "Open Tab " @!tab)
             [mui/tabs {:value          (or @!tab 0)
                        :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                        :indicatorColor "primary"
                        :textColor      "primary"
                        :variant        "scrollable"
                        }
              [mui/tab {:value 0 :label "Details"}]

              ; creating / isWaiting
              (when true [mui/tab {:value 2 :label (str "Zugeteilt (" (cnt-responseStatus-fn "member") ")")}])

              ;collecting  2
              (when (> training-step 1) [mui/tab {:value 3 :label (str (if (< training-step 3) "Eingeladen" "Einladung nicht angenommen") " (" (cnt-responseStatus-fn "invited") ")")}])


              (when (> training-step 1) [mui/tab {:value 4 :label (str "Zusagen (" (cnt-responseStatus-fn "accepted") ")")}])

              ;running 3
              ;(when (> training-step 1) [mui/tab {:value 7 :label (str "Reserve (" (cnt-missionStatus-fn "standby") ")")}])
              (when (> training-step 1) [mui/tab {:value 9 :label (str "Nicht erschienen (" (cnt-missionStatus-fn "absent") ")")}])
              (when (> training-step 1) [mui/tab {:value 8 :label (str "Teilnehmer (" (cnt-missionStatus-fn "participated") ")")}])
              ;(when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user) )}])
              ]
             ;;show-absent? show-standby? show-participated?
             (case (or @!tab 0)
               0 [training-detail-form/get-it !training !training-detail-loaded? (not= training-status "created")]
               1 [training-detail-form/get-it !training !training-detail-loaded? (not= training-status "created")]
               2 [mui/card-content {}
                  [(training-user-table/get-it (:trainingEvent-slotMember @!training) "member" nil
                                               {:ro? (> training-step 3) :allow-delete? (= training-step 0) :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? (> training-step 1) :show-alarm-answer? false :show-absent? false :show-standby? false :show-participated? false})]
                  ]
               3 [mui/card-content {}
                  [(training-user-table/get-it (:trainingEvent-slotMember @!training) "invited" nil
                                               {:ro? (> training-step 3) :allow-delete? true :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? false :show-alarm-answer? false :show-absent? false :show-standby? false :show-participated? false})]]

               4 [mui/card-content {}
                  [(training-slot-user-table/get-it (:trainingEvent-slotMember @!training) "accepted" "undefined"
                                                    {:ro? (> training-step 3) :allow-delete? true :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? false :show-alarm-answer? true :show-absent? false :show-standby? false :show-participated? false})]
                  ]

               7 [mui/card-content {}
                  [(training-user-table/get-it (:trainingEvent-slotMember @!training) nil "standby"
                                               {:ro? (> training-step 3) :allow-delete? true :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? false :show-alarm-answer? false :show-absent? false :show-standby? false :show-participated? false})]]

               9 [mui/card-content {}
                  [(training-slot-user-table/get-it (:trainingEvent-slotMember @!training) nil "absent"
                                                    {:ro? (> training-step 3) :allow-delete? true :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? false :show-alarm-answer? false :show-absent? false :show-standby? false :show-participated? false})]]

               8 [mui/card-content {}
                  [(training-slot-user-table/get-it (:trainingEvent-slotMember @!training) nil "participated"
                                                    {:ro? (> training-step 3) :allow-delete? true :allow-accept? (> training-step 1) :allow-decline? (> training-step 1) :allow-invite? false :show-alarm-answer? false :show-absent? false :show-standby? false :show-participated? false})]]


               99 [mui/card-content {}
                   [:p "Übersicht über trainings....."]
                   [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!training)) "," ",\n")]]

               )
             ]]
           ])))))


















